import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

import "./Navbar.css";
import img1 from "../assets/img/logo.jpg";
import serviceimag1 from "../assets/img/Picture1.jpg";
import serviceimag2 from "../assets/img/Picture2.jpg";
import serviceimag3 from "../assets/img/Picture3.jpg";
import serviceimag4 from "../assets/img/Picture4.jpg";
import serviceimag5 from "../assets/img/Picture5.jpg";
import serviceimag6 from "../assets/img/Picture6.jpg";
import serviceimag7 from "../assets/img/Picture7.jpg";
import serviceimag8 from "../assets/img/Picture8.jpg";
import serviceimag9 from "../assets/img/Picture9.jpg";
import serviceimag10 from "../assets/img/Picture10.jpg";
import serviceimag11 from "../assets/img/Picture11.jpg";
import serviceimag12 from "../assets/img/Picture12.jpg";
export const servicesdata = [
  {
    id: 1,
    serviceimage: serviceimag1,
    cardtitle: "Bold Peanuts",
    title: "Bold Peanuts",
    description: "Premium quality Bold Peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",
      Minquantity: "28000 kg",
      Origin: "India",

      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: serviceimag1,
  },
  {
    id: 2,
    serviceimage: serviceimag2,
    cardtitle: "Java Peanut",
    title: "Java Peanut",
    description: "High-quality Java Peanuts, perfect for cooking.",
    specifications: {
      Type: "Fresh Onion",
      Minquantity: "28000 kg",
      Origin: "India",

      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: serviceimag2,
  },
  {
    id: 3,
    serviceimage: serviceimag3,
    cardtitle: "TJ Peanut",
    title: "TJ Peanut",
    description: "Premium quality TJ Peanut for various uses.",
    specifications: {
      Type: "TJ Peanut",
      Origin: "India",
      Color: "brown/mustard",
      Packing: "30kg",
      Minquantity: "28000 kg",
    },
    image: serviceimag3,
  },
  {
    id: 4,
    serviceimage: serviceimag4,
    cardtitle: "Roasted Blanched Peanuts",
    title: "Roasted Blanched Peanuts",
    description: "Premium quality Roasted Blanched Peanuts for various uses.",
    specifications: {
      Type: "Roasted Blanched Peanuts",
      Origin: "India",
      cultivationType: "natural",
      Packing: "50/100kg paper box",
    },
    image: serviceimag4,
  },
  {
    id: 5,
    serviceimage: serviceimag5,
    cardtitle: "Peanut split (Raw/Blanched)",
    title: "Peanut split (Raw/Blanched)",
    description: "Premium quality Peanut split (Raw/Blanched) for various uses.",
    specifications: {
      Type: "Peanut split (Raw/Blanched)",
      Origin: "India",
      cultivationType: "natural",
      Packing: "50/100kg paper box",
    },
    image: serviceimag5,
  },
  {
    id: 6,
    serviceimage: serviceimag8,
    cardtitle: "Psyllium Husk and Powder",
    title: "Psyllium Husk and Powder",
    description: "Premium quality Psyllium Husk and Powder for various uses.",
    specifications: {
      Color: "brown",
      Type: "Psyllium Husk and Powder",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",

      uses: "Human Consumption",
      Origin: "India",

      Packing: "25 kg pp bag",
    },
    image: serviceimag8,
  },
  {
    id: 7,
    serviceimage: serviceimag9,
    cardtitle: "PINK ONION",
    title: "PINK ONION",
    description: "Premium quality PINK ONION for various uses.",
    specifications: {
      Type: "PINK ONION",
      Color: "brown/creamy",

      Packing: "10/20kg Jute bag",

      Origin: "India",
    },
    image: serviceimag9,
  },
  {
    id: 8,
    serviceimage: serviceimag10,
    cardtitle: "Honey Mustard / Eucalyptus Hone",
    title: "Honey Mustard / Eucalyptus Honey",
    description: "Premium quality bold Honey Mustard / Eucalyptus Hone for various uses.",
    specifications: {
      Type: "Bold Honey Mustard / Eucalyptus Hone",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: serviceimag10,
  },
  {
    id: 9,
    serviceimage: serviceimag11,
    cardtitle: "Fresh Cavendish G9 Banana",
    title: "Fresh Cavendish G9 Banana",
    description: "Premium quality Fresh Cavendish G9 Bananas for various uses.",
    specifications: {
      Type: "Fresh Cavendish G9 Bananas",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: serviceimag11,
  },
  {
    id: 10,
    serviceimage: serviceimag12,
    cardtitle: "PEANUT BUTTER",
    title: "PEANUT BUTTER",
    description: "Premium quality PEANUT BUTTER for various uses.",
    specifications: {
      Type: "PEANUT BUTTER",
      Origin: "India",
      Grade: "Low-temperature crushing, Free from aflatoxin, salmonella and e. coli, Exceptional colour and viscosity",
      Packing: "As per Requirement",
    },
    image: serviceimag12,
  },
  {
    id: 11,
    serviceimage: serviceimag6,
    cardtitle: "Cummin",
    title: "Cumin",
    description: "Premium quality Cumins for various uses.",
    specifications: {
      taste: "sweet",

      Type: "Cumins",
      form: "gel",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "250g 5kg(client pref), glass bottle jar (client pref)",
      Minquantity: "100 kg",
      Origin: "India",
    },
    image: serviceimag6,
  },
  {
    id: 11,
    serviceimage: serviceimag7,
    cardtitle: "Cummin",
    title: "Cumin",
    description: "Premium quality Cumins for various uses.",
    specifications: {
      taste: "sweet",

      Type: "Cumins",
      form: "gel",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "250g 5kg(client pref), glass bottle jar (client pref)",
      Minquantity: "100 kg",
      Origin: "India",
    },
    image: serviceimag7,
  },
  // Repeat for the rest of the products
];
export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  const [sticky, setSticky] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Close dropdown and mobile menu after link click
  const closeMenus = () => {
    setIsDropdownOpen(false);
    setMenuOpen(false);
  };

  return (
    <nav className={`nav ${sticky ? "sticky" : ""}`}>
      <div className="navbar-brand">
        <Link to="/">
          <img className="img-fluid" src={img1} alt="Logo" />
        </Link>
      </div>

      {/* Hamburger menu for mobile view */}
      <div className="menu" onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Main navigation links */}
      <ul className={menuOpen ? "open" : ""}>
        <li className="nav-item">
          <Link to="/" onClick={closeMenus}>
            Home
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/aboutus" onClick={closeMenus}>
            About Us
          </Link>
        </li>

        {/* Products dropdown menu */}
        <li className="nav-item" onClick={toggleDropdown} ref={dropdownRef}>
          Products
          {isDropdownOpen && (
            <ul className="dropdown">
              <Link to="/peanuts" onClick={closeMenus}>
                <li className="dropdown-item">Peanuts</li>
              </Link>

              <Link to="/psylliumhusk" onClick={closeMenus}>
                <li className="dropdown-item">Psyllium Husk and Powder</li>
              </Link>
              <Link to="/onion" onClick={closeMenus}>
                <li className="dropdown-item">Pink Onion</li>
              </Link>
              <Link to="/honey" onClick={closeMenus}>
                <li className="dropdown-item">Honey Mustard / Eucalyptus Honey</li>
              </Link>
              <Link to="/banana" onClick={closeMenus}>
                <li className="dropdown-item">Fresh Cavendish G9 Banana</li>
              </Link>
              <Link to="/peanutbutter" onClick={closeMenus}>
                <li className="dropdown-item">Peanut Butter</li>
              </Link>
              <Link to="/cummin" onClick={closeMenus}>
                <li className="dropdown-item">Cummins</li>
              </Link>
            </ul>
          )}
        </li>

        <li className="nav-item">
          <Link to="/certificate" onClick={closeMenus}>
            Certifications
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/contactus" onClick={closeMenus}>
            Contact
          </Link>
        </li>
      </ul>
    </nav>
  );
};